import { Config } from "../../Config";
var NetworkingRequest = /** @class */ (function () {
    function NetworkingRequest() {
    }
    NetworkingRequest.isValidProcessRequestUrl = function (url) {
        var _a;
        var trimmed = (_a = url === null || url === void 0 ? void 0 : url.trim()) !== null && _a !== void 0 ? _a : "";
        if (!trimmed)
            return false;
        try {
            var parsed = new URL(trimmed);
            return parsed.protocol === "http:" || parsed.protocol === "https:";
        }
        catch (_b) {
            return false;
        }
    };
    NetworkingRequest.setClientApiKey = function (apiKey) {
        NetworkingRequest.clientApiKey = apiKey !== null && apiKey !== void 0 ? apiKey : "";
    };
    NetworkingRequest.MAX_ERRORS_ALLOWED = 2;
    NetworkingRequest.clientApiKey = "";
    NetworkingRequest.send = function (requestBlob, sessionRequestCallback, resultCallback) {
        if (resultCallback === void 0) { resultCallback = null; }
        if (!NetworkingRequest.isValidProcessRequestUrl(Config.FaceTecProcessRequestURL)) {
            if (process.env.NODE_ENV === "development") {
                console.warn("FaceTec: process request URL is missing or invalid. Set API_URL so FaceTecProcessRequestURL is defined.");
            }
            sessionRequestCallback.abortOnCatastrophicError();
            return;
        }
        var request = new XMLHttpRequest();
        request.timeout = 2 * 60 * 1000;
        function openAndSendRequest() {
            request.open("POST", Config.FaceTecProcessRequestURL);
            request.setRequestHeader("Content-Type", "application/json");
            request.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
            var setHeaders = new Set();
            var setHeaderOnce = function (name, value) {
                var trimmedName = (name !== null && name !== void 0 ? name : "").trim();
                var trimmedValue = (value !== null && value !== void 0 ? value : "").trim();
                if (!trimmedName || !trimmedValue)
                    return;
                var key = trimmedName.toLowerCase();
                if (setHeaders.has(key))
                    return;
                setHeaders.add(key);
                request.setRequestHeader(trimmedName, trimmedValue);
            };
            // Precedence: client-provided API key overrides env-provided key.
            if (NetworkingRequest.clientApiKey) {
                // API key provided by the client via `auth/attempt/client`.
                setHeaderOnce("x-api-key", NetworkingRequest.clientApiKey);
            }
            if (Config.ApiKeyName && Config.ApiKeyValue) {
                // Backward compat: env-configured API key header.
                setHeaderOnce(Config.ApiKeyName, Config.ApiKeyValue);
            }
            request.send(JSON.stringify({ requestBlob: requestBlob }));
        }
        var errorCount = 0;
        request.onload = function () {
            var _a, _b, _c;
            if (request.status !== 200) {
                sessionRequestCallback.abortOnCatastrophicError();
                return;
            }
            try {
                var parsed = JSON.parse((_a = request.responseText) !== null && _a !== void 0 ? _a : "{}");
                if (resultCallback === null || resultCallback === void 0 ? void 0 : resultCallback.onSuccess)
                    resultCallback.onSuccess(parsed, sessionRequestCallback);
                var responseBlob = (_c = (_b = parsed === null || parsed === void 0 ? void 0 : parsed.responseBlob) !== null && _b !== void 0 ? _b : parsed === null || parsed === void 0 ? void 0 : parsed.scanResultBlob) !== null && _c !== void 0 ? _c : null;
                if (typeof responseBlob !== "string" || responseBlob.length === 0) {
                    sessionRequestCallback.abortOnCatastrophicError();
                    return;
                }
                sessionRequestCallback.processResponse(responseBlob);
            }
            catch (_d) {
                sessionRequestCallback.abortOnCatastrophicError();
            }
        };
        request.onerror = function (ev) {
            if (errorCount < NetworkingRequest.MAX_ERRORS_ALLOWED) {
                errorCount++;
                setTimeout(openAndSendRequest, errorCount * 1000);
                return;
            }
            sessionRequestCallback.abortOnCatastrophicError();
        };
        request.ontimeout = function () {
            sessionRequestCallback.abortOnCatastrophicError();
        };
        request.upload.onprogress = function (ev) {
            if (!ev.lengthComputable)
                return;
            sessionRequestCallback.updateProgress(ev.loaded / ev.total);
        };
        openAndSendRequest();
    };
    return NetworkingRequest;
}());
export { NetworkingRequest };
